import * as React from "react"
import * as WordService from "../../service/sfp/word-service"
import { ReducerState, MappedActionsProps } from "../../reducer";
import { bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import * as actionCreators from "../../action-creators";

class GlossaryComponent extends React.Component<InjectedProps, State>{
    constructor(props) {
        super(props);
        this.state = {
            nombreMotsGabarit: null,
            file: null
        }
    }
    private ReportNames: ReportTypeConfiguration[] = [{ label: "Personnalisé", value: "Personalized" },
    { label: "Prospective", value: "Standard1" },
    { label: "Rétrospective", value: "Standard2" },
    { label: "Débat d'Orientation Budgétaire", value: "DOB" },];
    private selectedReport: ReportTypeConfiguration;
    private selectedFile: File;

    componentDidMount() {
        this.selectedReport = this.ReportNames[0];
        this.updateNbWords(this.selectedReport.value);
    }

    //#region Réaction Formulaire
    onSelectRdgChange = (e: any): any => {
        let idx = this.ReportNames.findIndex(o => o.value == e.target.value);
        if (idx > -1) {
            this.selectedReport = this.ReportNames[idx];
            this.updateNbWords(this.selectedReport.value)
        }
    }

    onFileChange = (e: any): any => {
        this.setState({
            file: e.target.files[0]
        });
        this.selectedFile = e.target.files[0]
    }

    async onDownloadClick() {
        const response = await WordService.exportGlossary(this.selectedReport.value);
        if (response.status == 200) {
            const blob = await response.blob();
            // Créer un objet URL pour le blob
            const url = window.URL.createObjectURL(blob);
            // Créer un élément d'ancrage invisible pour le téléchargement
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Glossaire_' + this.selectedReport.value + '.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    onImporterClick() {
        WordService.importGlossary(this.selectedFile, this.selectedReport.value).then(value => {
            this.updateNbWords(this.selectedReport.value);
        });
    }
    //#endregion

    updateNbWords(gabarit: string) {
        this.setState({ nombreMotsGabarit: null });

        WordService.getNumberOfWordsByGabarit(gabarit).then(value => this.setState({ nombreMotsGabarit: value }));
    }

    clearFile() {
        this.setState({
            file: null
        });
        this.selectedFile = null;
    }

    render() {
        //#region STYLES
        const formContainer = {
            marginLeft: "20px",
        }

        const formDiv = {
            marginBottom: "10px",
        }

        const formElem = {
            marginLeft: "5px",
        }

        const button = {
            marginTop: "5px",
            marginLeft: "5px",
        }

        const inputFile = {
            marginLeft: "5px",
        }

        const inputContainer = {
            width: "400px",
        }
        //#endregion

        return <section>
            <header className="hero">
                <div className="hero-body">
                    <h1 className="title">Gestion du glossaire</h1>
                </div>
            </header>

            <div className="field" style={formContainer}>
                <label className="label" htmlFor="selectRdg">Type de rapport de gestion</label>
                <div className="control" style={formDiv}>
                    <div className="select">
                        <select
                            className="input"
                            id="selectRdg"
                            name="selectRdg"
                            onChange={this.onSelectRdgChange}>
                            {this.ReportNames.map((option) => (
                                <option key={option.value} value={option.value}>{option.label}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div style={formDiv}>
                    {
                        this.state.nombreMotsGabarit != null && this.state.nombreMotsGabarit > 0 ?
                            <label>Le glossaire du rapport {this.selectedReport.label} contient {this.state.nombreMotsGabarit} définitions</label>
                            : this.state.nombreMotsGabarit != null ? <label>Le glossaire du rapport {this.selectedReport.label} ne contient pas encore de définition</label> : ''
                    }
                </div>
                <div className="columns content">
                    <div className="column is-half-desktop">
                        <label className="label">Import du glossaire</label>
                        <label htmlFor="inputGlossary" style={formElem}>Sélection du fichier :</label>
                        <div style={inputContainer} className="formDiv">
                            <input onChange={this.onFileChange} className="input" name="inputGlossary" type="file" accept="text/csv" style={inputFile} />
                        </div>
                        <button className="button is-primary" style={button} onClick={() => this.onImporterClick()} disabled={this.state.file == null || this.state.file == undefined}>Importer</button>
                    </div>
                    <div className="column is-half-desktop">
                        <label className="label">Export du glossaire</label>
                        <button className="button is-primary" style={button} onClick={() => this.onDownloadClick()}>Télécharger</button>
                    </div>
                </div>
            </div>
        </section>
    }

    onChange() {

    }
}

interface ReportTypeConfiguration {
    value: string,
    label: string
}

interface State {
    nombreMotsGabarit: number;
    file: File;
}

function mapDispatchToProps(
    dispatch: Dispatch<ReducerState>
): MappedActionsProps {
    return { actions: bindActionCreators(actionCreators, dispatch) };
}

function mapStateToProps(state: ReducerState): ReducerState {
    return state;
}

export default connect(mapStateToProps, mapDispatchToProps)(GlossaryComponent);

type InjectedProps = MappedActionsProps & ReducerState;


// WEBPACK FOOTER //
// ./src/component/glossary/glossary-component.tsx